import { render, staticRenderFns } from "./openQuestion.vue?vue&type=template&id=b4bb7e4c&scoped=true"
import script from "./openQuestion.vue?vue&type=script&lang=js"
export * from "./openQuestion.vue?vue&type=script&lang=js"
import style0 from "./openQuestion.vue?vue&type=style&index=0&id=b4bb7e4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4bb7e4c",
  null
  
)

export default component.exports